import { createInjectionKey } from "../../_utils/index.mjs";
export const avatarGroupInjectionKey = createInjectionKey('n-avatar-group');